import Head from "next/head"
import React from "react"
import { Default, MetaKey, MetaProps } from "."

// -----------------------------
// Opengraph Docs — https://ogp.me/
// Facebook Opengraph for Video: https://developers.facebook.com/docs/sharing/webmasters#video

// <meta name="keywords" content="DEFAULT_KEYWORDS, profile_name, profile_name" />
export const Keywords = (props: MetaProps) => {
  const { keywords } = props

  const defaultKeys = Default.Keywords

  return (
    <Head>
      <meta
        data-testid={MetaKey.Keywords}
        key={MetaKey.Keywords}
        name={MetaKey.Keywords}
        content={keywords ? defaultKeys.concat(", ", keywords) : defaultKeys}
      />
    </Head>
  )
}
